// users
import Vue from "vue";
import Vuetify from "vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import router from "./router_contact";
import "vuetify/dist/vuetify.min.css";
window.Vue = Vue;
Vue.use(VueAxios, axios);
Vue.use(Vuetify);
const app_admin = new Vue({
    el: "#app",
    router,
    vuetify: new Vuetify()
});
